import { Chip, Stack, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { OptionsDirection } from './options-direction'

const options = [
    {
        label: 'Blend-in',
        value: 'blend-in'
    },
    {
        label: 'Discreet',
        value: 'discreet'
    },
    {
        label: 'Evident',
        value: 'evident'
    }
]

export const OptionsNavColor = (props) => {
    const { onChange, value } = props

    return (
        <Stack spacing={1}>
            <Typography
                color="text.secondary"
                variant="overline"
                sx={{ mt: 4 }}
            >
                Nav Color
            </Typography>
            <Stack alignItems="center" direction="row" flexWrap="wrap" gap={2}>
                {options.map((option) => (
                    <Chip
                        key={option.label}
                        label={option.label}
                        onClick={() => onChange?.(option.value)}
                        sx={[
                            {
                                borderColor: 'transparent',
                                borderStyle: 'solid',
                                borderWidth: 2
                            },
                            option.value === value && {
                                borderColor: 'primary.main'
                            }
                        ]}
                    />
                ))}
            </Stack>
        </Stack>
    )
}

OptionsNavColor.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.oneOf(['blend-in', 'discreet', 'evident'])
}
